import { Container } from './styles';
import 'react-datepicker/dist/react-datepicker.css';
import React from 'react';

import { FaCalendarAlt } from 'react-icons/fa';

import DatePicker, { registerLocale } from 'react-datepicker';
import br from 'date-fns/locale/pt-BR';
registerLocale('br', br);

interface IDate {
  Onchange: (e: Date) => void;
  value: Date;
}

const InputDatePicker: React.FC<IDate> = (props) => {
  return (
    <Container>
      <DatePicker
        selected={props.value}
        onChange={props.Onchange}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        minDate={new Date()}
        filterDate={(date) => date.getDay() !== 0}
        dateFormat='dd/MM/yyyy'
        dropdownMode='select'
        locale={'br'}
      />
      <FaCalendarAlt style={{ pointerEvents: 'none', cursor: 'pointer' }} />
    </Container>
  );
};

export default InputDatePicker;
